import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs/internal/Observable';
import * as fromDokuLightActions from '../actions/doku-light.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {InvoicesRestService} from '../../services/api/invoices.rest-service';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class DokuLightEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);

    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    loadDokuLight$: Observable<any> = createEffect(() => {
        return this.actions$
            .pipe(ofType<fromDokuLightActions.LoadDokuLightAction>(fromDokuLightActions.DokuLightActionTypes.LOAD_DOKU_LIGHT))
            .pipe(
                map(action => action.payload),
                switchMap((productRequest) =>
                    this.productRestService.loadDokuLight(productRequest).pipe(
                        switchMap(data => {
                            const returnObject = data.returnObject;
                            if (returnObject && returnObject.list) {
                                // Check if there are any products to filter
                                returnObject.list = this.productRestService.filterProducts.length > 0
                                    ? returnObject.list.filter(product => !this.productRestService.filterProducts.includes(product.id))
                                    : returnObject.list;

                                const prodResp = new ProductsResponse({...returnObject});

                                return [
                                    new fromDokuLightActions.LoadDokuLightCompleteAction(prodResp),
                                    new fromDokuLightActions.GetBatchFromCacheAction()
                                ];
                            }
                        }),
                        catchError((error) => of(new fromDokuLightActions.LoadDokuLightFailAction(error)))
                    )
                )
            );
    });


    searchDokuLight$: Observable<any> = createEffect(() => {
        return this.actions$
        .pipe(ofType<fromDokuLightActions.SearchShopAction>(fromDokuLightActions.DokuLightActionTypes.SEARCH_DOKU_LIGHT))
        .pipe(map(action => action.payload), switchMap((productRequest) => [new fromDokuLightActions.LoadDokuLightAction(productRequest)]
        ));
    });

}
